export default __webpack_public_path__ + "static/media/airdockz-blk-2.d4ffe471.png";